import Typography from '@mui/material/Typography';
import { Translation, useNavigate } from '@ps/web-shared-components';
import { addSeconds, format } from 'date-fns';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useRequest from '@swf/core/hooks/useRequest';
import useTimer from '@swf/core/hooks/useTimer';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { type Dispatch, select } from '@swf/core/store';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_Inactivity_Timeout,
  TXTCLI_Logout,
  TXTCLI_You_will_be_disconnected_due_t_ELL,
  TXTWCL_Continue_using_the_site
} from './InactivityTimeoutPrompt.messages.json';

const secondsDecrement = (seconds: number) => seconds - 1;

interface Props {
  remainingSeconds: number;
  onClose: () => void;
}

const InactivityTimeoutPrompt: React.FC<Props> = ({ remainingSeconds, onClose }) => {
  const request = useRequest();
  const continueUsingSite = () => request({ service: '/api/v1-preview/account' });

  const { auth } = useDispatch<Dispatch>();
  const exitWizard = useWizardExit();
  const navigate = useNavigate();
  const { redirectTo } = useSelector(select.localSettings.get);

  const secondsLeft = useTimer({
    modifier: secondsDecrement,
    initial: remainingSeconds
  });

  const handleClose = () => {
    redirectTo ? navigate(redirectTo) : exitWizard();
    auth.logout();
    onClose();
  };

  if (secondsLeft === 0) {
    handleClose();
  }

  return (
    <Prompt
      onClose={onClose}
      variant="default"
      title={{ translation: TXTCLI_Inactivity_Timeout }}
      primaryButton={{ translation: TXTWCL_Continue_using_the_site }}
      secondaryButton={{ translation: TXTCLI_Logout }}
      onPrimaryButtonClick={continueUsingSite}
      onSecondaryButtonClick={handleClose}
    >
      <Typography>
        <Translation {...TXTCLI_You_will_be_disconnected_due_t_ELL} />
      </Typography>
      <Typography>{format(addSeconds(new Date(0), secondsLeft), 'mm:ss')}</Typography>
    </Prompt>
  );
};

export default InactivityTimeoutPrompt;
